<template>
<div class="chapter">
<div class="inner_page">
<h1 class="titlepage" id="pageiii">SPITFIRE!</h1>
<p class="titlepage1">THE FULL STORY OF A UNIQUE BATTLE OF BRITAIN FIGHTER SQUADRON</p>
<p class="titlepage2">DILIP SARKAR</p>
<p class="logo"><img alt="" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?dff2378a